import sdk from '@trazi/search/sdk/node';

const tzsearchDomain = () => {
  if (process.env.ENVIRONMENT === 'production') {
    return `${process.env.WEBSITE}.com`;
  }
  return process.env.TESTING_ACCOUNT_DOMAIN || 'traziventures.com';
};

/**
 * Builds a Trazi Search SDK client
 *
 * @param {object} [options]
 * @param {string} [options.baseUrl] - Search origin, defaults to SEARCH_SDK_BASE_URL
 * @param {object} [options.headers] - Extra headers merged onto tzsearch_domain
 * @param {import('http').Agent} [options.agent] - Optional keep-alive agent for this client
 * @returns {object}
 */
export const createSearchSDK = ({ baseUrl, headers = {}, agent } = {}) => {
  const resolvedBaseUrl = baseUrl || process.env.SEARCH_SDK_BASE_URL;
  const sdkOptions = {
    headers: { tzsearch_domain: tzsearchDomain(), ...headers }
  };

  if (agent) {
    sdkOptions.agent = agent;
  }

  return sdk(resolvedBaseUrl, sdkOptions);
};
